import * as React from "react";
import styled from "@emotion/styled";
import { BaseStyleAttrs } from "@/theme";

export type InputTextProps = { background?: string } & BaseStyleAttrs & React.InputHTMLAttributes<HTMLInputElement>;

const StyledInput = styled.input<BaseStyleAttrs>`
  margin: ${({ margin = "0" }) => margin};
  padding: ${({ padding = "1px 6px" }) => padding};
  width: ${({ width = "100%" }) => width};
  height: ${({ height = "45px" }) => height};
  box-sizing: border-box;
  transition: all 0.3s;
  border: 2px solid #959595;
  text-align: left;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0px;
  color: #666666;
  opacity: 1;

  &:focus {
    background: #eee;
    outline: none;
  }
`;

const InputText = ({ ...props }: InputTextProps) => {
  return <StyledInput {...props} />;
};

export default InputText;
